/**
 * Hook to check if the shop page is loading or not
 * @returns {Object} An object containing the loading state and the shop index page
 * @returns {boolean} isLoading - True if the shop page is loading
 * @returns {CmsPageDetail} shopIndexPage - The shop index page
 * @returns {CmsPageDetail} cmsPageDetail - The CMS page detail
 */

import { useCmsPageByCode } from "@/features/shop/cms/hooks/useCmsPageByCode";
import { useCmsPages } from "@/features/shop/cms/hooks/useCmsPages";

const SHOP_INDEX_PAGE_CODE = "shop_index";

type UseShopPageLoadingStateOptions = { enabled?: boolean };

export const useShopPageLoadingState = ({ enabled = true }: UseShopPageLoadingStateOptions = {}) => {
  const { cmsPages } = useCmsPages();
  const { data: cmsPageDetail, isLoading, isError } = useCmsPageByCode({ code: SHOP_INDEX_PAGE_CODE, enabled });

  const shopIndexPage = cmsPages?.find((page) => page.code === SHOP_INDEX_PAGE_CODE) ?? cmsPageDetail;

  const isShopPageReady = !!shopIndexPage && !isLoading && !isError && !!cmsPageDetail;

  return {
    isLoading: !isShopPageReady,
    shopIndexPage,
    cmsPageDetail,
  };
};
